import { Record } from 'immutable';

const EventHasItemsByVendorRecord = Record({
  hasReservationsByVendor: null,
  hasRsvpsByVendor: null
});

export class EventHasItemsByVendor extends EventHasItemsByVendorRecord {
  hasReservationsByVendor: { [key: number]: boolean };
  hasRsvpsByVendor: { [key: number]: boolean };
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-has-items-by-vendor.ts